import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BottomBar from '@/components/feature/BottomBar';
import HeroSection from '@/pages/home/components/HeroSection';
import ProblemSection from '@/pages/home/components/ProblemSection';
import MedicineCareSection from '@/pages/home/components/MedicineCareSection';
import FeaturesGrid from '@/pages/home/components/FeaturesGrid';
import SeniorAppSection from '@/pages/home/components/SeniorAppSection';
import EmergencySection from '@/pages/home/components/EmergencySection';
import DischargeCompanion from '@/pages/home/components/DischargeCompanion';
import FamilyDashboard from '@/pages/home/components/FamilyDashboard';
import HowItWorks from '@/pages/home/components/HowItWorks';
import WhoItsFor from '@/pages/home/components/WhoItsFor';
import Benefits from '@/pages/home/components/Benefits';
import Testimonials from '@/pages/home/components/Testimonials';
import PricingSection from '@/pages/home/components/PricingSection';
import TrustSafety from '@/pages/home/components/TrustSafety';
import CTAFinal from '@/pages/home/components/CTAFinal';

export default function Home() {
  return (
    <div className="font-sans min-h-screen bg-white pb-20 md:pb-0">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <MedicineCareSection />
        <FeaturesGrid />
        <SeniorAppSection />
        <EmergencySection />
        <DischargeCompanion />
        <FamilyDashboard />
        <HowItWorks />
        <WhoItsFor />
        <Benefits />
        <Testimonials />
        <PricingSection />
        <TrustSafety />
        <CTAFinal />
      </main>
      <Footer />
      <BottomBar />
    </div>
  );
}